import { useEffect, useState } from 'react';

const SelectBatches = ({
  setDisable,
  courses,
  setTestData,
  testData,
  loadingCourses,
}) => {
  const [errors, setErrors] = useState([]);
  const [selectedCourseData, setSelectedCourseData] = useState(null);

  useEffect(() => {
    if (testData?.courseId && courses.length > 0) {
      const course = courses.find((c) => c.courseId === testData.courseId);
      setSelectedCourseData(course || null);
    } else {
      setSelectedCourseData(null);
    }
  }, [testData?.courseId, courses]);

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    setTestData((prevTestData) => ({
      ...prevTestData,
      courseId: courseId,
      batchStructureId: '',
      batchId: '',
    }));
  };

  const handleBatchStructureChange = (event) => {
    const batchStructureId = event.target.value;
    setTestData((prevTestData) => ({
      ...prevTestData,
      batchStructureId: batchStructureId,
      batchId: '',
    }));
  };

  const handleBatchChange = (event) => {
    const batchId = event.target.value;
    setTestData((prevTestData) => ({
      ...prevTestData,
      batchId: batchId,
    }));
  };

  useEffect(() => {
    const newErrors = [];
    if (!testData?.courseId?.trim()) {
      newErrors.push('Please select a course');
    }
    if (!testData?.batchStructureId?.trim()) {
      newErrors.push('Please select a batch structure');
    }
    if (!testData?.batchId?.trim()) {
      newErrors.push('Please select a batch');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [setDisable, testData]);

  const getBatchStructuresForCourse = () => {
    if (!selectedCourseData) return [];
    return selectedCourseData.batchStructures || [];
  };

  const getBatchesForStructure = () => {
    const structures = getBatchStructuresForCourse();
    const selectedStructure = structures.find(
      (s) => s.batchStructureId === testData?.batchStructureId
    );
    return selectedStructure?.batches || [];
  };

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Course, Batch Structure & Batch
        </h4>
      </div>

      <div className="mt-6 flex flex-col gap-6">
        <div className="mx-auto w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            onChange={handleCourseChange}
            value={testData?.courseId || ''}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : (
              <>
                {courses.map((course, i) => (
                  <option key={course.courseId} value={course.courseId}>
                    {i + 1}. {course.courseName} {course.isGlobal ? '(Global)' : ''}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>

        {selectedCourseData && (
          <div className="mx-auto w-full md:w-1/2">
            <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
              Select Batch Structure
            </label>
            <select
              onChange={handleBatchStructureChange}
              value={testData?.batchStructureId || ''}
              name="batchStructure"
              className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
            >
              <option value="">Click here to Select Batch Structure</option>
              {getBatchStructuresForCourse().length === 0 ? (
                <option>No batch structures available</option>
              ) : (
                <>
                  {getBatchStructuresForCourse().map((structure, i) => (
                    <option
                      key={structure.batchStructureId}
                      value={structure.batchStructureId}
                    >
                      {i + 1}. {structure.batchStructureName}
                    </option>
                  ))}
                </>
              )}
            </select>
          </div>
        )}

        {testData?.batchStructureId && (
          <div className="mx-auto w-full md:w-1/2">
            <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
              Select Batch
            </label>
            <select
              onChange={handleBatchChange}
              value={testData?.batchId || ''}
              name="batch"
              className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
            >
              <option value="">Click here to Select Batch</option>
              {getBatchesForStructure().length === 0 ? (
                <option>No batches available</option>
              ) : (
                <>
                  {getBatchesForStructure().map((batch, i) => (
                    <option key={batch._id} value={batch._id}>
                      {i + 1}. Batch {batch.batchNumber} {batch.branches && batch.branches.length > 0 ? `(${batch.branches.join(', ')})` : ''}
                    </option>
                  ))}
                </>
              )}
            </select>
          </div>
        )}
      </div>

      {errors.length > 0 && (
        <div className="mt-4 text-center text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectBatches;
